import React, { ReactElement } from 'react'

interface Props {
  cssClass: string
  children: string | ReactElement
  clickEvent: any
}
export function Button (props: Props): ReactElement {
  function clickEvent (): void {
    props.clickEvent()
  }

  return <>
      <div className={'button ' + props.cssClass} onClick={() => clickEvent()}>{props.children}</div>
  </>
}
